// src/components/accountComponents/taxSettings/accountTaxSettings.jsx
import React, { Component } from 'react';
import TmReactTable from '../../../utilComponents/tmReactTable/tmReactTable';
import { connect } from 'react-redux';
import { 
  getAccountTaxSettings, 
  saveAccountTaxSettings, 
  toggleAccountTaxable, 
  updateAccountTaxRate 
} from '../../../../actions/adminAction/taxSettingsActions';
import { notify } from '../../../../util/notifications';

class AccountTaxSettings extends Component {
  constructor() {
    super();
    this.state = {
      loading: false
    };
    this.handleToggleTaxable = this.handleToggleTaxable.bind(this);
    this.handleUpdateTaxRate = this.handleUpdateTaxRate.bind(this);
    this.handleSaveSettings = this.handleSaveSettings.bind(this);
  }

  componentDidMount() {
    const { dispatch, accountId } = this.props;
    this.setState({ loading: true });
    dispatch(getAccountTaxSettings(accountId)).finally(() => {
      this.setState({ loading: false });
    });
  }

  handleToggleTaxable(chargeListId) {
    const { dispatch } = this.props;
    dispatch(toggleAccountTaxable(chargeListId));  // Use the new action
  }
  
  handleUpdateTaxRate(chargeListId, rate) {
    const { dispatch } = this.props;
    dispatch(updateAccountTaxRate(chargeListId, rate));  // Use the new action
  }

  async handleSaveSettings() {
    const { dispatch, accountTaxSettings, accountId, refNotify } = this.props;
    this.setState({ loading: true });
    
    const res = await dispatch(saveAccountTaxSettings(accountTaxSettings, accountId));
    this.setState({ loading: false });
    
    if (res.statusCode === 200) {
      notify.createNotification('success', res.statusMsg, refNotify);
    } else {
      notify.createNotification('error', res.statusMsg, refNotify);
    }
  }

  render() {
    const { accountTaxSettings } = this.props;
    const { loading } = this.state;

    // Split charges into DEFAULT and CUSTOM groups
    const defaultCharges = accountTaxSettings.filter(charge => charge.global === true);
    const customCharges = accountTaxSettings.filter(charge => charge.global === false);

    const columns = [
      {
        Header: 'Charges',
        accessor: 'chargeName',
        filterable: true,
        minWidth: 200
      },
      {
        Header: 'Taxable',
        accessor: 'isTaxable',
        filterable: true,
        minWidth: 100,
        style: { textAlign: 'center' },
        Cell: props => (
          <input
            type="checkbox"
            checked={props.value}
            onChange={() => this.handleToggleTaxable(props.original.chargeListId)}
          />
        )
      },
      {
        Header: 'Percent',
        accessor: 'taxRate',
        filterable: true,
        minWidth: 150,
        Cell: props => (
          <input
            type="number"
            className="form-control"
            value={props.value}
            onChange={(e) => this.handleUpdateTaxRate(props.original.chargeListId, e.target.value)}
            disabled={!props.original.isTaxable}
            step="0.1"
            min="0"
            max="100"
          />
        )
      }
    ];

    return (
      <div className="row">
        <div className="col-md-12">
          <div className="pd-10 mb-20">
            <div className="clearfix mb-10">
              <h5 className="float-left">Tax Settings</h5>
              <div className="float-right">
                <button
                  className="btn btn-primary btn-sm"
                  onClick={this.handleSaveSettings}
                  disabled={loading}
                >
                  {loading ? <i className="fa fa-spinner fa-spin"></i> : <i className="fa fa-save"></i>} Save
                </button>
              </div>
            </div>

            {/* DEFAULT CHARGES */}
            <div className="mb-10">
              <h6>DEFAULT CHARGES</h6>
              <TmReactTable
                filterable
                sortable
                resizable
                defaultPageSize={5}
                data={defaultCharges}
                columns={columns}
                className="-striped -highlight"
              />
            </div>

            {/* CUSTOM CHARGES */}
            <div>
              <h6>CUSTOM CHARGES</h6>
              <TmReactTable
                filterable
                sortable
                resizable
                defaultPageSize={5}
                data={customCharges}
                columns={columns}
                className="-striped -highlight"
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  accountTaxSettings: state.taxSettings.accountTaxSettings,
  refNotify: state.refNotify
});

export default connect(mapStateToProps)(AccountTaxSettings);